import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import League from './League';
import Loading from '../../Common/Loading';
import * as Maps from '../../../store/map';

function Locations(props) {
    const handleClick = (e, locationId) => {
        e.preventDefault();
        let { selectedLocation } = props.lSports.prematch;
        let locState = selectedLocation === locationId || locationId === null ? false : true;
        locationId = locState ? locationId : null;
        props.lsportsActions.prematch.selectLocation(locationId);
    };

    let { locations, selectedLocation } = props.lSports.prematch;
    var locationLength = locations ? locations.length : 0;

    const locationsList = locations ? (
        locations.map((item, i) => {
            let locationId = item.Id;
            let locationName = item.Name;
            let count = item.Count;
            let divider = locationLength - 1 > i ? <div className="sports-divider"> </div> : null;

            return (
                <div className={`section ${selectedLocation === locationId ? 'open' : ''}`} key={locationId}>
                    <Row className="justify-content-md-center sectionhead mx-auto p-0 pb-2 " onClick={(e) => handleClick(e, locationId)}>
                        <Col xs="2" lg="2" className="p-0">
                            <div country={'flag_' + locationId} className="flag"></div>
                        </Col>
                        <Col xs="8" lg="8" md="auto" className="p-0">
                            {locationName}
                        </Col>
                        <Col xs="1" lg="1" md="auto" className="p-0">
                            {count}
                        </Col>
                        <Col xs="1" lg="1" md="auto" className="p-0">
                            <button>toggle</button>
                        </Col>
                    </Row>
                    {divider}

                    <League leagues={item.Leagues} />
                </div>
            );
        })
    ) : (
        <Loading />
    );

    return <div className="disable-select pt-3">{locationsList}</div>;
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(Locations);
